import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import {
  ICustomerState,
  reducer as customerReducer,
} from './customer/customer.reducer';

import {
  IVerificationState,
  reducer as verificationReducer,
} from './verification/verification.reducer';

export const DATA_ACCESS_CUSTOMER_DETAILS_FEATURE_KEY = 'customer';
export interface ICustomerFeatureState {
  customer: ICustomerState;
  verificationReducer: IVerificationState;
}

export const reducers: ActionReducerMap<ICustomerFeatureState> = {
  customer: customerReducer,
  verificationReducer: verificationReducer,
};

export const getCustomerFeatureState =
  createFeatureSelector<ICustomerFeatureState>(
    DATA_ACCESS_CUSTOMER_DETAILS_FEATURE_KEY
  );

export { ICustomerState };
